import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { DescriptionOutlined, LibraryBooksOutlined, KeyboardBackspace } from '@material-ui/icons'

import { createQuote } from '../../../utils/createQuote'
import { validateEmail } from '../../../utils/validation'

import { uploadQuote } from '../../../actions/upload'

import './Order.css'

const Order = ({ setShowSignup }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [validEmail, setValidEmail] = useState(true)
    const reloadQuote = useSelector(state => state.upload)
    const [data, setData] = useState({
        email: '', projectName: '', translatorNote: ''
    })
    const disable = !reloadQuote.files || data.email.trim() === '' || data.projectName.trim() === "" || loading || !validateEmail(data.email)
    
    const handleChange = (key, value) => {
        if(key === 'email') {
            setValidEmail(validateEmail(value))
        }
        setData({...data, [key]: value})
        dispatch(uploadQuote({...data, [key]: value}))
    }

    const handleContinue = (e) => {
        e.preventDefault()

        if(disable) return false

        setLoading(true)
        
        if(localStorage.getItem('auth')) createQuote(reloadQuote, setLoading, dispatch, history)
        else setShowSignup(true)        
    }

    useEffect(() => {
        if(reloadQuote.email) {
            setData(data => ({
                ...data, email: reloadQuote.email
            }))
        }
        if(reloadQuote.projectName) {
            setData(data => ({
                ...data, projectName: reloadQuote.projectName
            }))
        }
        if(reloadQuote.translatorNote) {
            setData(data => ({
                ...data, translatorNote: reloadQuote.translatorNote
            }))
        }
        return () => {
          setData({email: '', projectName: '', translatorNote: ''})
        }
    }, [reloadQuote])

    return (
        <>
        <form className="orderForm mb-40">
            <h3 className="mt-20 mb-40">Project Information</h3>
            <div className="orderForm__label d-flex justify-between mb-40">
                <label className="w-45">
                    <p className="font-heavy mb-10 ml-5">Project Name<sup className="font-bold ml-5">*</sup></p>
                    <input className="input" type="text" value={data.projectName} onChange={e => handleChange('projectName', e.target.value)} required />
                </label>
                <label className="w-45 position-relative">
                    <p className="font-heavy mb-10 ml-5">Email<sup className="font-bold ml-5">*</sup></p>
                    <input className="input" type="email" value={data.email} onChange={e => handleChange('email', e.target.value)} required />
                    {!validEmail && <div className="error-input">Invalid Email</div>}
                </label>
            </div>
            <label className="w-100">
                <p className="font-heavy mb-10 ml-5">Note for translator</p>
                <textarea className="input" placeholder="Leave a note for translator" value={data.translatorNote} onChange={e => handleChange('translatorNote', e.target.value)} />
            </label>
        </form>
        <h3>Your Files</h3>
        <div className="my-40">
            {reloadQuote.files &&
                reloadQuote.files.map((file, i) => 
                    <div className="d-flex justify-between my-10" key={file.name.concat(i)}>
                        <span className="d-flex align-center"><DescriptionOutlined className="icon-light-grey mr-10"/> {file.name}</span>
                        <span>{isNaN(file.count) ? 'NA' : `(${file.count} words)`}</span>
                    </div>
                )
            }
        </div>
        <div className="d-flex justify-between my-40">
            <span className="d-flex align-center"><LibraryBooksOutlined className="icon-light-grey mr-10"/> 
                {reloadQuote.files ?
                    `${reloadQuote.files.length} document${reloadQuote.files.length > 1 ? 's' : ''}`
                    :
                    'No document'
                }
            </span>
            {reloadQuote.files && <span>{isNaN(reloadQuote.totalCount) ? 'NA' : `(${reloadQuote.totalCount} words)`}</span>}
        </div>
        <div className="d-flex justify-between pt-40 p b-20">
            <button className="button bg-transparent d-flex align-center" onClick={() => history.push('/quote')}><KeyboardBackspace className="mr-10"/> Back</button>
            <button  className="d-flex align-center justify-center border-1 outline-0 py-10 rounded pointer" onClick={handleContinue} disabled={disable} style={{opacity: disable ? 0.6 : ''}}>
                Continue
                {loading && <div className="spin-white ml-10"></div>}
            </button>
        </div>
        </>
    )
}

export default Order
